export default __webpack_public_path__ + "static/media/Acreditation.a32f2693.PNG";